import { TypeIcon } from "../common/TypeIcon";
import { Link } from "react-router-dom";
import type { EntityInfo } from "../../hooks/useEntityMap";
import { stayHotelName, stayNightsLabel, type HotelStay } from "../../utils/hotelStays";
import { type Zone } from "../../utils/tripDisplay";
import "./Stays.css";

/**
 * Today's "Staying at …" card, shown while you're out of the hotel mid-stay:
 * one tap logs the stay's next visit, Arrived now, without searching for it.
 */
export function BackAtHotelCard({
  stay,
  hotel,
  tripId,
  zone,
  onBack,
  busy,
}: {
  stay: HotelStay;
  hotel: EntityInfo | undefined;
  tripId: string;
  zone?: Zone;
  onBack: () => void;
  busy?: boolean;
}) {
  const name = stayHotelName(stay, hotel, "the hotel");
  const leftAt = stay.end
    ? stay.end.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit", timeZone: zone })
    : null;
  return (
    <div className="back-at-hotel">
      <h3 className="ctc-section-title">Staying at</h3>
      <div className="back-at-hotel-card">
        <Link to={`/trips/${tripId}/stays/${stay.id}`} className="back-at-hotel-head">
          <span className="stay-card-icon" aria-hidden="true">
            {hotel?.imageUrl ? <img src={hotel.imageUrl} alt="" /> : <TypeIcon type="HOTEL" tile />}
          </span>
          <span className="stay-card-text">
            <span className="stay-card-name">{stayHotelName(stay, hotel)}</span>
            <span className="stay-card-sub">
              {stayNightsLabel(stay, zone)}
              {leftAt ? ` · out since ${leftAt}` : ""}
            </span>
          </span>
        </Link>
        <button type="button" className="btn back-at-hotel-btn" onClick={onBack} disabled={busy}>
          Back at {name}
        </button>
      </div>
    </div>
  );
}
